Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    fontBold = _STYLES$useStyles.fontBold,
    container = _STYLES$useStyles.container;
  var _container = Object.assign({}, container, {
    marginTop: spacing.xxxl
  });
  var textContainer = {
    textAlign: 'center',
    maxWidth: _styles.STYLES.grid.maxTextBlockWidth,
    alignSelf: 'center'
  };
  var actions = {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s])) {
    actions.flexDirection = 'column-reverse';
  }
  var actionsTextContainer = {
    width: 'auto',
    marginBottom: 0,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  };
  var actionsText = Object.assign({}, fontBold, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s
  });
  var styles = _reactNative.StyleSheet.create({
    container: _container,
    textContainer: textContainer,
    actions: actions,
    actionsTextContainer: actionsTextContainer,
    actionsText: actionsText
  });
  return {
    styles: styles
  };
};